module.exports = __webpack_public_path__ + "static/img/logo20.f1d11a0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo20.png
// module id = oic7
// module chunks = 1